import { logWarning } from '@/services/errorService'

type FbqFn = ((...args: unknown[]) => void) & {
	callMethod?: (...args: unknown[]) => void
	queue?: unknown[]
	loaded?: boolean
	version?: string
}

declare global {
	interface Window {
		fbq?: FbqFn
		_fbq?: FbqFn
	}
}

// Prevents re-initialisation when the location hook re-runs with the same pixelId.
let activePixelId: string | null = null

export function initMetaPixel(pixelId: string): void {
	if (!pixelId || activePixelId === pixelId) return
	activePixelId = pixelId

	// Standard Meta Pixel bootstrap — mirrors V1's ember-metrics FacebookPixel adapter.
	const n: FbqFn = function (...args: unknown[]) {
		if (n.callMethod) {
			n.callMethod(...args)
		} else {
			;(n.queue ??= []).push(args)
		}
	}
	window.fbq = n
	window._fbq = n
	n.loaded = true
	n.version = '2.0'
	n.queue ??= []

	const script = document.createElement('script')
	script.async = true
	script.src = 'https://connect.facebook.net/en_US/fbevents.js'
	document.head.appendChild(script)

	window.fbq('init', pixelId)
	window.fbq('track', 'PageView')
}

export function trackAddToCart(itemName: string, subtotalCents: number, currency: string): void {
	try {
		window.fbq?.('track', 'AddToCart', {
			content_name: itemName,
			value: subtotalCents / 100,
			currency,
		})
	} catch (e) {
		logWarning('[metaPixel] Failed to track AddToCart event', { error: e })
	}
}

export function trackPurchase(
	totalWithTipCents: number,
	currency: string,
	cartItems: ReadonlyArray<{
		readonly id: string
		readonly quantity: number
		readonly item_name: string
		readonly item_price: number
	}>,
): void {
	try {
		window.fbq?.('track', 'Purchase', {
			value: totalWithTipCents / 100,
			currency,
			contents: cartItems.map((item) => ({
				id: item.id,
				quantity: item.quantity,
				item_name: item.item_name,
				item_price: item.item_price,
			})),
			content_type: 'product',
			content_name: 'SkyTab Online',
		})
	} catch (e) {
		logWarning('[metaPixel] Failed to track Purchase event', { error: e })
	}
}
